import React from "react";
import DHSelectionComponent from "./DHSeclectionCompontent";

// Auswahl 10 bis 30 Aufnahmen, angezeigt werden die Darts (3 Darts je Aufnahme)
const BULLEN_ZUR_AUSWAHL = [{name: 'Auswahl löschen', code: undefined}];
for (let aufnahmen = 10; aufnahmen <= 30; aufnahmen++) {
    BULLEN_ZUR_AUSWAHL.push({name: "nach " + (aufnahmen * 3) + " Darts je Spieler", code: aufnahmen});
}

export function GameAusbullenComponent({aufnahmenBisBullen, onChange, disabled}) {
    return <DHSelectionComponent value={aufnahmenBisBullen} onChange={onChange} values={BULLEN_ZUR_AUSWAHL} title="Ausbullen" disabled={disabled}/>
}
